var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService, PermissionsService, HelpersService } from '@base-shared/services';
import { TranslateService } from '@ngx-translate/core';
var PermissionsGuard = /** @class */ (function () {
    function PermissionsGuard(router, auth, permissions, helpers, translate) {
        this.router = router;
        this.auth = auth;
        this.permissions = permissions;
        this.helpers = helpers;
        this.translate = translate;
    }
    PermissionsGuard.prototype.canActivate = function (next, state) {
        var _this = this;
        var _permission = next.data['permission'] || {};
        var lookUp = this.getItemId(__assign({}, next.params, next.queryParams));
        var observer = new Observable(function (obs) {
            _this.permissions.getSectionPermissions(_permission.type, lookUp)
                .then(function (authPermissions) {
                var canAccess = _this.permissions.checkPermissions(_permission.permissions, authPermissions);
                // display message
                if (!canAccess) {
                    var message = _this.translate.instant('common.not-authorized');
                    _this.helpers.infoMessage('', message);
                }
                if (!canAccess) {
                    console.log('==============> registration-test');
                    _this.router.navigate(['/eyrus/projects']);
                }
                return obs.next(canAccess);
            })
                .catch(function (err) { return obs.next(false); });
        });
        return observer;
    };
    /**
     * Trigger not authorized flow
     */
    PermissionsGuard.prototype.notAuthorized = function () {
        this.router.navigate(['/eyrus']);
        return false;
    };
    PermissionsGuard.prototype.getItemId = function (params) {
        var _a, _b;
        var validKeys = ['contractId', 'contractDefinitionId', 'projectId', 'dailyLogId', 'contractWalkthroughId'];
        var childs = [];
        var payload = {};
        var keys = Object.keys(params);
        var shouldUseLast = ['contractWalkthroughId'];
        var useLast = false;
        if (keys.indexOf('childContractId') !== -1) {
            keys.push('contractDefinitionId');
            params['contractDefinitionId'] = params['childContractId'];
        }
        if (keys.indexOf('rootContractId') !== -1 && keys.indexOf('contractId') === -1) {
            keys.push('contractId');
            params['contractId'] = params['rootContractId'];
        }
        for (var index = 0; index < keys.length; index++) {
            // if (shouldUseLast.indexOf(keys[index]) !== -1)
            //   useLast = true;
            if (validKeys.indexOf(keys[index]) !== -1) {
                payload = (_a = {}, _a[keys[index]] = params[keys[index]], _a);
                childs.push((_b = {}, _b[keys[index]] = params[keys[index]], _b));
            }
        }
        if (childs.length)
            payload = useLast ? childs[childs.length - 1] : childs[0];
        return payload;
    };
    return PermissionsGuard;
}());
export { PermissionsGuard };
